<template>
    <div>
        <div class="job-filter" style="display:flex;justify-content:space-between">
            <div>
                <span style="padding-left:15px;position:relative;top:2px">Show campaigns:</span>
                <button class="btn"
                        :class="{ 'btn-secondary': !filter_active, 'btn-primary': filter_active, 'disabled': loading }"
                        @click="activityFilter(true)">Active
                </button>
                <button class="btn"
                        :class="{ 'btn-secondary': filter_active, 'btn-primary': !filter_active, 'disabled': loading }"
                        @click="activityFilter(false)">Inactive
                </button>
            </div>
        </div>

        <div class="table-responsive" v-loading="loading">
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <th></th>
                    <th>Campaign</th>
                    <th># Jobs</th>
                    <th style="width: 100px;"></th>
                    <th style="width: 100px;"></th>
                </tr>
                </thead>

                <draggable
                    tag="tbody"
                    handle=".handle"
                    :list="list"
                    v-bind="drag_options"
                    @change="(obj) => orderChanged(obj)"
                >
                    <tr v-for="c in list" :class="{'campaign-inactive': c.hidden}">
                        <td style="width: 30px;">
                            <i class="handle fas fa-bars" v-if="filter_active"></i>
                        </td>
                        <td>
                            {{ c.name }}
                        </td>
                        <td>{{ c.jobs }}</td>
                        <td>
                            <a href="#" @click.prevent="update(c.id)" v-if="!c.hidden">update</a>
                        </td>
                        <td>
                            <a href="#" @click.prevent="reactivate(c.id)" v-if="c.hidden">reactivate</a>
                            <a href="#" @click.prevent="inactivate(c.id)" v-if="!c.hidden">inactivate</a>
                        </td>
                    </tr>
                </draggable>
            </table>
        </div>

        <btn icon="fas fa-plus" :click="addCampaign">Add campaign</btn>

        <campaign-update
            v-if="show_dialogs.campaign_id"
            :show="show_dialogs.update_campaign"
            :campaign_id="show_dialogs.campaign_id"
            :employer_id="data.employer_id"
            @updated="refresh"
            @close="show_dialogs.update_campaign = false"
        ></campaign-update>

        <campaign-create
            :show="show_dialogs.create_campaign"
            :employer_id="data.employer_id"
            @updated="refresh"
            @close="show_dialogs.create_campaign = false"
        ></campaign-create>

        <campaign-inactivate
            v-if="show_dialogs.campaign_id"
            :show="show_dialogs.inactivate_campaign"
            :campaign_id="show_dialogs.campaign_id"
            :employer_id="data.employer_id"
            @updated="refresh"
            @close="show_dialogs.inactivate_campaign = false"
        ></campaign-inactivate>

        <employer-notes-wrapper :employer-id="employerId"/>
    </div>
</template>

<script>
import CampaignUpdate from "./campaign-update";
import CampaignCreate from "./campaign-create";
import CampaignInactivate from "./campaign-inactivate";

export default {
    components: {CampaignInactivate, CampaignCreate, CampaignUpdate},
    props: [
        'data',
        'employerId',
    ],
    data() {
        return {
            show_dialogs: {
                update_campaign: false,
                campaign_id: null,
                create_campaign: false,
                inactivate_campaign: false,
            },
            drag_options: {
                animation: 200,
            },
            filter_active: true,
            list: [],
            loading: false
        };
    },
    methods: {
        refresh() {
            this.loading = true;
            return axios.post(url(`admin/employer/${this.data.employer_id}/campaigns/data`), {
                'active': this.filter_active
            }).then(response => {
                this.list = response.data.list;
                this.loading = false;
            });
        },
        activityFilter(activity) {
            this.filter_active = activity;
            return this.refresh();
        },
        update(id) {
            this.show_dialogs.campaign_id = id;
            this.show_dialogs.update_campaign = true;
        },
        addCampaign() {
            this.show_dialogs.create_campaign = true;
        },
        inactivate(id) {
            this.show_dialogs.campaign_id = id;
            this.show_dialogs.inactivate_campaign = true;
        },
        reactivate(id) {
            return axios.post(url(`admin/employer/${this.data.employer_id}/campaigns/${id}/reactivate`))
                .then(response => {
                    this.refresh();
                });
        },
        orderChanged() {
            let ids = _.map(this.list, (f) => f.id);
            return axios.post(url(`admin/employer/${this.data.employer_id}/campaigns/order-updated`), {
                ids: ids
            }).then(response => {
            });
        }
    },
    mounted() {
        this.refresh();
    },
};
</script>

<style>
.campaign-inactive {
    background: #ebcaca !important;
}
</style>
